import React, { useState } from 'react'
import { ButtonDropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { CloseIcon, FilterIcon, filterBlackIcon } from '../../../assets/images';
import { RadioTypes } from '../../../commonTypes/universalTypes';
import {  DropDown, RadioContainer } from '../../commons';


export const JOBS_PRIORITY_OPTION=[
  {value:"normal",label:"Normal"},
  {value:"red",label:"Red"},
  {value:"blue",label:"Blue"},
  {value:"green",label:"Green"},

]
type DropDownOptionType = {
  value: string | null;
  label: string;
}; 
type AppProps ={
    setData?:any;
    openStatus:string;
    openStatusValue:string;
    setClearFilter: (data: boolean) => void;
    setOpenStatusValue:React.Dispatch<React.SetStateAction<string>>;
    setOpenStatus:React.Dispatch<React.SetStateAction<string>>;
    setOffset: React.Dispatch<React.SetStateAction<number>>;
    jobPriority:DropDownOptionType;
    setJobPriority:React.Dispatch<React.SetStateAction<any>>;
    handleSubmit:()=>void;
    type?:string;

}
export const JOB_STATUS_RADIO_OPTIONS: RadioTypes[] = [
    {
      id: "Open",
      name: "Open",
    },
    {
      id: "Closed",
      name:"Closed",
    },
  ];
  
const JobProgressFilter = ({
setData,
setOffset,
openStatus,
openStatusValue,
setOpenStatus,
setOpenStatusValue,
setClearFilter,
jobPriority,
setJobPriority,
handleSubmit,
type

}:AppProps) => {
    const [toggle, setToggle] = useState<boolean>(false);
    const resetFilterData = () => {
        setOpenStatusValue(openStatus.toString());
      };
   
      const handleSetJobStatusRadioValue = (radioValue: string) => {
        setOpenStatusValue(radioValue);
      };
      const clearFilter = () => {
        setOpenStatusValue("");
        setOpenStatus("");
        setOffset(0);
        setClearFilter(true);
        setJobPriority({
          value: null,
          label: "Select..",
        });
      };
      const handleJobPriorityChange =(data :any)=>{
        setJobPriority({
          value:data?.value,
          label:data?.label
        })
      }
  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        resetFilterData();
        setToggle(!toggle);
      }}
    >
      <DropdownToggle
        caret
        color="secondary"
        style={
          toggle || ((openStatusValue !== "Open" && openStatusValue !== "Closed") &&   (jobPriority.value==null))
            ? { border: "1px solid#bfcbe1" }
            : {
                color: "#dd4433",
                border: "1px solid #dd4433",
                backgroundColor: "#fff6f5",
              }
        }
        outline
      >
       
        <img src={toggle?FilterIcon:filterBlackIcon } alt=""/>

      </DropdownToggle>

      <DropdownMenu right>
        <div className="download-dropdown p-3">
          <div className="d-flex justify-content-between align-items-center mt-0 mb-0">
            <h5 className="text-center ">Filter</h5>
            <div
              className="pointer"
              onClick={() => {
                setToggle(!toggle);
                setClearFilter(false);
              }}
            >
              <img src={CloseIcon} alt="" />
            </div>
          </div>
          <hr className="mt-0 mb-0" />
          {!type?
          <div className="mt-4 ml-1">
            <h4>Job Status</h4>
            <div>
              <RadioContainer
                optionsList={JOB_STATUS_RADIO_OPTIONS}
                handleSetRadioValue={handleSetJobStatusRadioValue}
                radioValue={openStatusValue}
                alignment="vertical"
              />
            </div>
          </div>:''}
             <div className='row d-flex mt-3'>
                    <div className='col-md-12'>
                    <h4>Job Priority</h4>
                    <div className='mt-1'>
                        <DropDown
                            options={JOBS_PRIORITY_OPTION}
                            value={jobPriority}
                            handleChange={handleJobPriorityChange}
                        />
                    </div>
                    </div>
                    </div>
        </div>

        <div className="d-flex align-items-center justify-content-end p-3 ">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="btn btn-primary mr-3"
            onClick={() => {
              handleSubmit();
              setToggle(!toggle);
            }}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  )
}

export default JobProgressFilter
